if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
      buyNow=undefined;
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.variantList = this.querySelector('.product-form__variants');
        this.quantityInput = this.querySelector('.quantity__input');
        this.selectedVariantID = this.querySelector('.product-variant-id').value;
        this.selectedVariantPrice = this.variantList.querySelector(`[value="${this.selectedVariantID}"]`).dataset.price;
        this.selectedVariantComparePrice = this.variantList.querySelector(`[value="${this.selectedVariantID}"]`).dataset.comparePrice;
        this.variantQty = this.variantList.querySelector(`[value="${this.selectedVariantID}"]`).dataset.variantQty;
        this.variantPolicy = this.variantList.querySelector(`[value="${this.selectedVariantID}"]`).dataset.inventoryPolicy;
        this.variantAvailable = this.variantList.querySelector(`[value="${this.selectedVariantID}"]`).dataset.variantAvailable;
        const variantMetaFiled = document.getElementById('product-variant-meta-filed').textContent || {};
        this.variantMetaFiled = JSON.parse(variantMetaFiled);
        this.updateVariantMetaField(this.selectedVariantID,this.selectedVariantPrice,this.selectedVariantComparePrice,this.variantQty,this.variantPolicy,this.variantAvailable);
        this.protectionLabels = document.querySelectorAll('.protection-plan-wrapper label');
        this.lifetimeInfo = document.querySelector('.lifetime-info');
        this.shippingDeliveryMsg = this.querySelector('.six_daysESt b');
        this.protectionLabels.forEach(label => {
          label.addEventListener('click', this.handleProtectionLabelClick.bind(this));
        });
      }
      handleProtectionLabelClick(event) {
        const closestDiv = event.target.closest('.grid__item');
        const protectionInput = closestDiv.querySelector('input');
        if(protectionInput.checked) {
          event.preventDefault();
          protectionInput.checked = false;
          protectionInput.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('hello');
        }
      }
      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        // console.log(event, target, selectedOptionValues);
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      protection_price_range(variant_price) {
        try {
          var is_bridal_product = theme.is_bridal,
            protection_variant_list;
          if (is_bridal_product) {
            protection_variant_list = theme.protection_product_lifetime;
          } else {
            protection_variant_list = theme.protection_product_3y;
            $("#product-input-option-1").val("1 Year");
            $("#product-input-option-2").val("2 Year");
            $(".product-protection-option-1 .update-year").text("1 Year");
            $(".product-protection-option-2 .update-year").text("2 Year");
            $(".product-protection-option-3 sup").hide();
          }
          var price_range = "";
          for (var obj in protection_variant_list) {
            var lower_price_range = obj.split(" / ")[1].split("-")[0] * 100;
            var higher_price_range = obj.split(" / ")[1].split("-")[1] * 100;
            if (
              variant_price >= lower_price_range &&
              variant_price <= higher_price_range
            ) {
              price_range = obj.split(" / ")[1];
              break;
            }
          }
          if (!price_range.length) {
            $(".product-clarity-commitment").hide();
            $(".product-clarity-commitment .protection-plan-wrapper input").prop(
              "checked",
              false
            );
            return false;
          }
          // console.log(protection_variant_list[`3 / ${price_range}`]);
          if (is_bridal_product) {
            return [
              ...protection_variant_list[`3 / ${price_range}`],
              ...protection_variant_list[`Lifetime / ${price_range}`]
            ];
          } else {
            return [
              ...protection_variant_list[`1 / ${price_range}`],
              ...protection_variant_list[`2 / ${price_range}`]
            ];
          }
        } catch (e) {
          console.log(e);
        }
      }
      variant_update_protection_price(data) {
        try {
          var [price_option1,variant_option1,price_option2,variant_option2] = this.protection_price_range(data);
          $(".product-protection-option-1").attr("data-protection-id", variant_option1).find("p .update-price").text(theme.Currency.formatMoney(price_option1, theme.moneyFormat));
          $(".product-protection-option-2").attr("data-protection-id", variant_option2).find("p .update-price").text(theme.Currency.formatMoney(price_option2, theme.moneyFormat));
        } catch (e) {
          console.log(e);
        }
      }
      updateShippingInfo(variantQty,variantPolicy,variantAvailable){
        const shipping_delivery_msg_parent = document.querySelector('.shipping-delivery-msg');
        const shipping_delivery_msg_selector = document.querySelector('.six_daysESt b');
        // console.log("variantAvailable",variantAvailable, typeof variantAvailable);
        if(variantAvailable == "true"){
          shipping_delivery_msg_parent.style.display = 'flex';
          if (variantQty < 1 && variantPolicy == "continue") {
            const ships_in_2_week_label = document.querySelector('.two-week-msg');
            ships_in_2_week_label && (ships_in_2_week_label.style.display = 'inline-block');
            const shipping_msg = theme.product_ship_14;
            const shipping_day = shipping_msg.split(",")[0];
            const shipping_date = parseInt(shipping_day.split(" ")[1]);
            const shipping_month = shipping_day.split(" ")[0];
            if(shipping_date <= theme.cutoff_date.day && shipping_month == theme.cutoff_date.month){
              shipping_delivery_msg_selector.innerHTML = `${theme.product_ship_14}. <span class="get-it-in-time test">${theme.cutoff_text_mto}</span>`;
            }else{
              shipping_delivery_msg_selector.textContent = shipping_msg;
            }
          }else{
            const ships_in_2_week_label = document.querySelector('.two-week-msg');
            ships_in_2_week_label && (ships_in_2_week_label.style.display = 'none');
            const shipping_msg = theme.product_ship_3;
            const shipping_day = shipping_msg.split(",")[0];
            const shipping_date = parseInt(shipping_day.split(" ")[1]);
            const shipping_month = shipping_day.split(" ")[0];
            if(shipping_date <= theme.cutoff_date.day && shipping_month == theme.cutoff_date.month){
              shipping_delivery_msg_selector.innerHTML = `${theme.product_ship_3}. <span class="get-it-in-time">${theme.cutoff_text}</span>`;
            }else{
              shipping_delivery_msg_selector.textContent = shipping_msg;
            }
          }
        }else{
          shipping_delivery_msg_parent.style.display = 'none';
        }
      }

      resetProductFormState() {
        const productForm = this.productForm;
        // productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          if(!variant.available){
            this.productForm?.toggleSubmitButton(true, window.variantStrings.soldOut);
          }else{
            this.productForm?.toggleSubmitButton(false);
          }
          if (!variant) {
            this.setUnavailable();
            return;
          }
          this.updateMedia(html, variant?.featured_media?.id,variant);
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');


          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        // this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      loadVariant360(activeVariant360Selector){
        const existingIframe = activeVariant360Selector.querySelector("iframe"); 
        if(!existingIframe) {
          const iframeSrc = activeVariant360Selector.querySelector(".iframe-360-view").dataset.iframe
          const iframe = document.createElement("iframe");
          iframe.src = iframeSrc;
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("frameborder", "0");  
          iframe.setAttribute("scrolling", "no");   
          activeVariant360Selector.appendChild(iframe);
        }
      }
      updateVariantMetaField(variantId,price,comparePrice,variantQty,variantPolicy,variantAvailable){
        const variantMetaField = this.variantMetaFiled[variantId] || {};
        const metalTypeSelector = document.querySelector('.metal-type');
        const centerStoneWeightSelector = document.querySelector('.center-stone-weight');
        const centerStoneShapeSelector = document.querySelector('.center-stone-shape');
        const totalDiamondWeightSelector = document.querySelector('.specification .total-diamond-weight');
        let updatedComparePrice = parseInt(comparePrice);
        let updatedPrice = parseInt(price);
        if(variantMetaField["metal-type"] && metalTypeSelector){
          metalTypeSelector.innerHTML = variantMetaField["metal-type"];
        }
        if(variantMetaField["center-stone-weight"] && centerStoneWeightSelector){
          centerStoneWeightSelector.innerHTML = variantMetaField["center-stone-weight"];
        }
        if(variantMetaField["center-stone-shape"] && centerStoneShapeSelector){
          centerStoneShapeSelector.innerHTML = variantMetaField["center-stone-shape"];
        }
        if(variantMetaField["total-diamond-weight"] && totalDiamondWeightSelector){
          totalDiamondWeightSelector.innerHTML = variantMetaField["total-diamond-weight"];
        }
        if(window.location.pathname.includes('final-ring')){
        }else{
          this.variant_update_protection_price(updatedComparePrice > updatedPrice?updatedComparePrice:updatedPrice);
        }
        this.updateShippingInfo(variantQty,variantPolicy,variantAvailable);
      }
      updateVariantImage(variant){
        var variantQty = this.variantList.querySelector(`[value="${variant.id}"]`).dataset.variantQty;
        var variantPolicy = this.variantList.querySelector(`[value="${variant.id}"]`).dataset.inventoryPolicy;
        var variantAvailable = this.variantList.querySelector(`[value="${variant.id}"]`).dataset.variantAvailable;
        if(theme.productTags.includes('enchanted-star')){
          var imageHandle = this.variantList.querySelector(`[value="${variant.id}"]`).dataset.variantHandle;
          if (this.variantList && window.innerWidth > 749){
            publish(PUB_SUB_EVENTS.variantData, {variant,imageHandle});
            if(imageHandle){
              document.querySelectorAll('.product__media-item:not(.all)').forEach(function(div){
                div.classList.remove('is-active');
              });
              document.querySelectorAll(`.${imageHandle}`).forEach(function(selector){
                selector.classList.add('is-active');
              });
              // var activeVariant360Selector = document.querySelector('.is-active.product__media-iframe');
              // this.loadVariant360(activeVariant360Selector);
            }
          } else {
            publish(PUB_SUB_EVENTS.variantData, {variant,imageHandle});
          };
          // console.log("variant",variant);
        }
        this.updateVariantMetaField(variant.id,variant.price,variant.compare_at_price,variantQty,variantPolicy,variantAvailable);
      }

      updateMedia(html, variantFeaturedMediaId,variant) {
        this.updateVariantImage(variant);
        if (!variantFeaturedMediaId) return;
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }
          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }
        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );
        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }
      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };
        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.quantityInput.min = min;
        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateQuantityRules(this.dataset.section, html);
        })
        .catch((e) => console.error(e))
        .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
